import axios from "axios";
const baseURL =
  process.env.REACT_APP_BACKEND_URL || "https://xherobackend.ygsltd.ng/api";
const axiosInstance = axios.create({
  baseURL,
  timeout: 10000,
});

export default axiosInstance;
